module.exports = __webpack_public_path__ + "static/img/1.3d81b14.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/21/1.png
// module id = sIpy
// module chunks = 0